angular.module('zc.zenclerkS')
  .component('zcsInvoiceNote', {
    templateUrl: '/templates/zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note.html',
    bindings: {
      month: '<'
    },
    controller: zcsInvoiceNoteController
  });

zcsInvoiceNoteController.$inject = ['ZcsOemService'];
function zcsInvoiceNoteController(ZcsOemService) {
  const vm = this;
  vm.$onInit = () => {
    vm.isMinimumCharge = moment(vm.month).isSameOrAfter(moment('2017-04-01'));
    vm.ZcsOemService = ZcsOemService;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note.js